// import { Route, Switch } from 'react-router';
import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import {
  CurrentPContextProvider,
  MasterContextProvider,
  MessagesObjCssContextProvider,
  MobiOrNotContextProvider,
  OrdStageContextProvider,
  OrderContextProvider,
  UserContextProvider
} from './ContextApi/context';
import MasterHead from "./Master//MasterHeads";
import Master from './Master/Master';
import Sitemap from './web_pages/SiteMap/SiteMap';
import FormPage from './web_pages/FormPublicPage/FormPage';
import { CityContextProvider } from './ContextApi/cityContext';
//זמן מקסימלי להמתין לתמונת ה-imgWaiting הדינמית לפני שמורידים את ה-splash בכל מקרה -
//רשת ביטחון בלבד, לא זמן תצוגה מובטח. אם imgWaiting לא יופיע כלל (כבוי, או העמוד
//כבר מוכן ברגע העלייה) ה-splash היה נשאר תקוע לנצח בלי זה
const SPLASH_MAX_WAIT_MS = 1500;

function App() {
  //מוחק את מסך ה-splash הסטטי (public/index.html) רק כשהדמות של imgWaiting כבר
  //נטענה ומוצגת (imgWaitingPicIn), או כשאין לעמוד תמונה (imgWaitingNoPic), או אחרי
  //SPLASH_MAX_WAIT_MS - המוקדם מביניהם. כך לא נשאר מסך לבן בזמן שהקובץ יורד
  //בלי רגע מסך-לבן ביניהם. מחיקה מיידית ב-mount הראשון (כמו קודם) הייתה קורית
  //הרבה לפני שה-master/העמוד בפועל נטענו, ויוצרת בדיוק את הפער הזה
  useEffect(() => {
    const splashRoot = document.getElementById('splashRoot');
    if (!splashRoot) return;

    let done = false;
    const removeSplash = () => {
      if (done) return;
      done = true;
      clearInterval(pollId);
      clearTimeout(timeoutId);
      splashRoot.remove();
    };

    const pollId = setInterval(() => {
      if (document.querySelector('.imgWaitingPicIn, .imgWaitingNoPic')) removeSplash();
    }, 50);
    const timeoutId = setTimeout(removeSplash, SPLASH_MAX_WAIT_MS);

    return () => {
      clearInterval(pollId);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <MobiOrNotContextProvider>
      <CityContextProvider>
      <MasterContextProvider>
        <UserContextProvider>
          <OrderContextProvider>
            <MessagesObjCssContextProvider>
              <CurrentPContextProvider>

                <OrdStageContextProvider>
                  <Router>
                    <Switch>
                      {/* Route for /sitemap */}
                      <Route path="/sitemap" component={Sitemap} />

                      {/* טופס ציבורי - קישור לא-ניחושי, בלי shell ה-Master */}
                      <Route path="/f/:slug" component={FormPage} />

                      {/* Default Route */}
                      <Route path="/">
                        <div className="webMain">
                          <MasterHead />
                          <Master />
                        </div>
                      </Route>
                    </Switch>
                  </Router>

                </OrdStageContextProvider>

              </CurrentPContextProvider>
            </MessagesObjCssContextProvider>
          </OrderContextProvider>
        </UserContextProvider>
      </MasterContextProvider >
      </CityContextProvider>
    </MobiOrNotContextProvider>
  );
}

export default App;
